import * as z from 'zod';
import {
  requiredEmail,
  requiredPhoneSchema,
  requiredText,
} from '@/modules/service-requests/shared/application-utils';

export const businessCardApplySchema = z.object({
  name: requiredText('NAME_REQUIRED', 150),
  designation: requiredText('DESIGNATION_REQUIRED', 150),
  email: requiredEmail('EMAIL_REQUIRED'),
  mobileNumber: requiredPhoneSchema('PHONE_NUMBER_REQUIRED'),
});

export type BusinessCardApplyValues = z.infer<typeof businessCardApplySchema>;
